import { useReaction } from "../avatar";
import { useDonatePanel } from "../donate";
import { DONATE_REACTION } from "./nav-items";

type Props = { onSelect?: () => void };

export function DonateButton({ onSelect }: Props) {
  const panel = useDonatePanel();
  const reaction = useReaction(DONATE_REACTION);
  return (
    <button
      type="button"
      className="donate-button glass"
      data-glass-interactive
      aria-haspopup="dialog"
      aria-label="Donate to my personal account"
      {...reaction}
      onClick={() => {
        onSelect?.();
        panel.open();
      }}
    >
      <span className="donate-button__full">Donate to my personal account</span>
      <span className="donate-button__short" aria-hidden="true">
        Donate
      </span>
    </button>
  );
}
